const PASSWORDS: Record<string, string> = {
  test: 'Case-X9p!2000',
};

export default PASSWORDS;
